import eventBus from '@tools/event-bus';

// SEO2K20
export default function () {
  function deobfuscateLinks(obfuscatedElementsClassParent = '') {
    const obfuscatedElementsClass = 'obfsc';

    // Avoid having multiple event listener on the same element, when it was reloaded multiple times (ie: notifications)
    const obfuscatedElementsSelector = obfuscatedElementsClassParent !== ''
      ? `${obfuscatedElementsClassParent} .${obfuscatedElementsClass}`
      : `.${obfuscatedElementsClass}`;

    // Each elements has at least a "${obfuscateAttributeName}-href" attribute
    document.querySelectorAll(`${obfuscatedElementsSelector}`).forEach((obfuscatedLinkElement) => {
      obfuscatedLinkElement.addEventListener('auxclick', () => {
        const link = atob(obfuscatedLinkElement.getAttribute(`data-${obfuscatedElementsClass}-href`));
        window.open(link, '_blank', 'noopener');
      });
      obfuscatedLinkElement.addEventListener('click', () => {
        const linkTarget = obfuscatedLinkElement.getAttribute(`data-${obfuscatedElementsClass}-target`) ?? '_parent';
        const link = atob(obfuscatedLinkElement.getAttribute(`data-${obfuscatedElementsClass}-href`));

        if (linkTarget === '_blank') {
          window.open(link, linkTarget);
        } else {
          window.location.assign(link);
        }
      });
    });
  }

  deobfuscateLinks();

  const deobfuscateLinksListener = (event) => {
    deobfuscateLinks(event.detail || '');
  };

  eventBus.addEventListener('deobfuscate-links', deobfuscateLinksListener);
}
